import React, { ReactElement } from 'react';
import { TextField } from '@material-ui/core';
import { FastFieldProps, Field } from 'formik';

interface FieldProps {
  name: string;
  label?: string;
  className?: string;
  touched?: boolean;
  validate?: (values: object) => string;
  inputProps?: object;
  FormHelperTextProps?: object;
  SelectProps?: object;
  InputLabelProps?: object;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const SimpleField: React.FC<FieldProps> = ({
  name,
  label,
  inputProps,
  touched,
  ...props
}) => {
  return (
    <Field name={name}>
      {({ field, meta }: FastFieldProps): ReactElement => {
        const { value, ...remainingField } = field;
        return (
          <TextField
            {...field}
            key={`${field.name}_input`}
            fullWidth
            placeholder={label}
            variant="outlined"
            size="small"
            value={value || ''}
            error={Boolean((touched || meta.touched) && meta.error)}
            helperText={(touched || meta.touched) && meta.error}
            {...remainingField}
            {...props}
            inputProps={inputProps}
          />
        );
      }}
    </Field>
  );
};
